var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.16504,
    width: 42,
    height: 42,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3618C10 12.5896 10.2703 11.9526 10.8108 11.4506C11.3513 10.9487 12.0541 10.6978 12.9189 10.6978C13.7683 10.6978 14.4556 10.9448 14.9807 11.4391C15.5212 11.9487 15.7915 12.6128 15.7915 13.4313C15.7915 14.1727 15.529 14.7904 15.0039 15.2846C14.4633 15.7943 13.7529 16.0491 12.8726 16.0491H12.8494C12 16.0491 11.3127 15.7943 10.7876 15.2846C10.2625 14.775 10 14.134 10 13.3618ZM10.3012 33.6321V18.1572H15.444V33.6321H10.3012ZM18.2934 33.6321H23.4363V24.9912C23.4363 24.4506 23.4981 24.0336 23.6216 23.7402C23.8378 23.2151 24.166 22.7711 24.6062 22.4082C25.0463 22.0452 25.5984 21.8638 26.2626 21.8638C27.9923 21.8638 28.8571 23.0298 28.8571 25.3618V33.6321H34V24.7595C34 22.4738 33.4595 20.7402 32.3784 19.5588C31.2973 18.3773 29.8687 17.7866 28.0927 17.7866C26.1004 17.7866 24.5483 18.6437 23.4363 20.358V20.4043H23.4131L23.4363 20.358V18.1572H18.2934C18.3243 18.6514 18.3398 20.1881 18.3398 22.7673C18.3398 25.3464 18.3243 28.968 18.2934 33.6321Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.16504,
    width: 42,
    height: 42,
    rx: 9,
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.6d0d0556cfcad72732d2e2b5db1c996b.svg";
export { ForwardRef as ReactComponent };